// Library shortcuts for the Shortcuts dialog: the clause search above a document's contents tree.
import type { ShortcutDef } from "@/app/shortcuts";

export const LIBRARY_SHORTCUTS: readonly ShortcutDef[] = [
  { id: "library-search", keys: [["/"]], description: "Focus the clause search" },
];
